import { DOM } from 'aurelia-pal';
import { LinkHandler, DefaultLinkHandler, BrowserHistory, AnchorEventInfo } from 'aurelia-history-browser';

/**
 * The default LinkHandler implementation. Navigations are triggered by click events on
 * anchor elements with relative hrefs when the history instance is using pushstate.
 */
export class ScopedLinkHandler extends LinkHandler {
	private handler: (event: Event) => void;
	private history: BrowserHistory;
	/**
	 * Creates an instance of DefaultLinkHandler.
	 */
	constructor() {
		super();

		this.handler = (e) => {
			const {shouldHandleEvent, href} = DefaultLinkHandler.getEventInfo(e);
			if (!shouldHandleEvent) {
				return;
			}

			if (!this.isInsideAureliaRoot(e.target as Element)) {
				return;
			}

			if (this.isServerLink(e.target as Element)) {
				return;
			}

			e.preventDefault();
			this.history.navigate(href);
		};
	}

	private isInsideAureliaRoot(element: Element) {
		if (!element) {
			return false;
		}

		return this.hasAureliaRoot(element.parentElement);
	}

	private hasAureliaRoot(element: Element) {
		if (element.hasAttribute('aurelia-root')) {
			return true;
		}

		if (!element.parentElement) {
			return false;
		}

		return this.hasAureliaRoot(element.parentElement);
	}

	private isServerLink(element: Element) {
		return element.hasAttribute('server-link');
	}

	/**
	 * Activate the instance.
	 *
	 * @param history The BrowserHistory instance that navigations should be dispatched to.
	 */
	activate(history: BrowserHistory): void {
		this.history = history;
		DOM.addEventListener('click', this.handler, true);
	}

	/**
	 * Deactivate the instance. Event handlers and other resources should be cleaned up here.
	 */
	deactivate(): void {
		DOM.removeEventListener('click', this.handler, true);
	}
}
